<script>
  import { onMount } from "svelte"
  import { push } from "svelte-spa-router"
  import {
    whenScreenTransitionFunc,
    questionnaireSetId,
    targetSetId,
    vocabularySetId,
    targetWords
  } from "./stores.js"
  import axios from "axios"

  const API_URL = process.env.API_URL
  let testList = []
  let answers = []
  let ansGrade
  let ansGender
  let isLocked = false
  let isExcluded = false // その他回答時の終了フラグ
  let questionnaireRefs = []
  let errorRefs = []
  let gradeRef = null
  let gradeErrorRef = null
  let genderRef = null
  let genderErrorRef = null
  let questionnaireSet = null
  let gradeList = []
  let genderList = [
    { id: 1, gender: "男性" },
    { id: 2, gender: "女性" },
    { id: 3, gender: "その他" },
    { id: 4, gender: "回答しない" },
  ]

  function nextScroll(num) {
    if (num < testList.length - 1) {
      questionnaireRefs[num + 1].scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      })
    }
  }

  onMount(async () => {
    whenScreenTransitionFunc()

    const urlParams = new URLSearchParams(window.location.search)
    const targetParam = urlParams.get("t")
    const vocabularyParam = urlParams.get("v")
    const questionnaireParam = urlParams.get("q")
    const monitorId = urlParams.get("id")
    const eqtid = urlParams.get("eqtid")

    if (monitorId && eqtid) {
      sessionStorage.setItem("monitor_id", monitorId)
      sessionStorage.setItem("eqt_id", eqtid)
      sessionStorage.setItem("id", `${monitorId}${eqtid}`)
    }

    if (targetParam && vocabularyParam && questionnaireParam) {
      targetSetId.set(targetParam)
      vocabularySetId.set(vocabularyParam)
      questionnaireSetId.set(questionnaireParam)

      try {
        const apiUrl = API_URL + "/get_test"
        const params = new URLSearchParams({
          target: targetParam,
          vocabulary: vocabularyParam,
        })

        const response = await axios.get(`${apiUrl}?${params.toString()}`)

        let targetWordList = []
        if (response.data.target && response.data.vocabulary) {
          const targetData = response.data.target.Item
          targetWordList = targetData.target_words || []
        } else {
          const testList = response.data["test"].Items
          targetWordList = testList.filter((item) => item["kind"] == 0)
        }

        targetWords.set(targetWordList)
      } catch (error) {
        console.error("ターゲット語の事前取得に失敗しました:", error)
      }
    }

    try {
      const response = await axios.get(
        `${API_URL}get_questionnaire?id=${questionnaireParam}`
      )
      questionnaireSet = response.data.questionnaire
    } catch (error) {
      alert(
        "アンケートの読み込みに失敗しました。再度URLからアクセスしてください。"
      )
    }

    if (
      !questionnaireSet ||
      !questionnaireSet.grade_options ||
      !questionnaireSet.questions
    ) {
      alert("アンケートデータの形式が正しくありません")
      return
    }

    gradeList = questionnaireSet.grade_options.map((grade, index) => ({
      id: index + 1,
      grade: grade,
    }))

    testList = questionnaireSet.questions
    answers = testList.map(() => null)
  })

  async function questionAnswer() {
    let nextFlag = 0
    let gradeFlag = 0
    let genderFlag = 0
    isLocked = true

    // MEMO: マーケティング会社との連携のためその他回答時は終了
    if (ansGrade && ansGrade.grade === "その他") {
      isExcluded = true
      isLocked = false
      scrollTo(0, 0)
      const monitorId = sessionStorage.getItem("monitor_id")
      const eqtId = sessionStorage.getItem("eqt_id")

      if (monitorId && eqtId) {
      await new Promise(resolve => setTimeout(resolve, 2000));
        const redirectUrl = `https://rsch.jp/common/connect_end.php?id=${monitorId}&eqtid=${eqtId}&state=8lUjzMGEMY`
        window.location.href = redirectUrl
      }
      return
    }

    if (ansGrade) {
      gradeRef.style.border = "medium solid #ffffff"
      gradeErrorRef.style.visibility = "hidden"
      gradeFlag = 1
    } else if (!ansGrade) {
      gradeRef.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      })
      gradeRef.style.border = "medium solid #f08080"
      gradeErrorRef.style.visibility = "visible"
      gradeFlag = 0
    }
    if (ansGender) {
      genderRef.style.border = "medium solid #ffffff"
      genderErrorRef.style.visibility = "hidden"
      genderFlag = 1
    } else if (!ansGender) {
      genderRef.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      })
      genderRef.style.border = "medium solid #f08080"
      genderErrorRef.style.visibility = "visible"
      genderFlag = 0
    }
    errorRefs.forEach((ref) => {
      ref.style.visibility = "hidden"
    })
    questionnaireRefs.forEach((ref) => {
      if (ref.tagName === "TABLE") {
        ref.style.backgroundColor = "#ffffff"
      } else {
        ref.style.border = "1px solid #cccccc"
      }
    })
    let unansweredIndices = answers.reduce((indices, answer, i) => {
      if (answer === null || answer === "") indices.push(i)
      return indices
    }, [])
    if (unansweredIndices.length > 0) {
      unansweredIndices.forEach((i) => {
        errorRefs[i].style.visibility = "visible"
        if (testList[i].type === "choice") {
          questionnaireRefs[i].style.backgroundColor = "#f08080"
        } else {
          questionnaireRefs[i].style.border = "medium solid #f08080"
        }
      })
    } else {
      nextFlag = 1
    }
    if (gradeFlag && genderFlag) {
      if (nextFlag) {
        let processedAnswers = answers.map((answer, i) => {
          return testList[i].type === "choice" ? parseInt(answer) + 1 : answer
        })
        const postResult = {
          action: "set_questionnaire",
          category: "questionnaire_result",
          id: sessionStorage.getItem("id"),
          result: processedAnswers,
          grade: ansGrade,
          gender: ansGender,
          questionnaire_set_id: questionnaireSet.id,
        }
        const response = await axios.post(API_URL + "/set_result", postResult)
        const questionnaireId = response.data.id
        sessionStorage.setItem("questionnaireId", questionnaireId)
        push("/attention")
      } else {
        questionnaireRefs[unansweredIndices[0]].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        })
      }
    }
    isLocked = false
  }
  function nonGrade() {
    if (!ansGrade) {
      gradeRef.style.border = "medium solid #f08080"
      gradeErrorRef.style.visibility = "visible"
    } else {
      gradeRef.style.border = "medium solid #ffffff"
      gradeErrorRef.style.visibility = "hidden"
    }
  }
  function nonGender() {
    if (!ansGender) {
      genderRef.style.border = "medium solid #f08080"
      genderErrorRef.style.visibility = "visible"
    } else {
      genderRef.style.border = "medium solid #ffffff"
      genderErrorRef.style.visibility = "hidden"
    }
  }
</script>

<!-- MEMO: マーケティング会社との連携のためその他回答時は終了 -->
{#if isExcluded}
  <div class="wrapper" style="text-align: center; margin-top: 20vh;">
    <h4>
      <p>このアンケートは対象外です。</p>
      <p>ご協力ありがとうございました。</p>
    </h4>
  </div>
{:else}
  <div class="wrapper">
    <h4>学年と性別を選んでください</h4>
  <div
    bind:this={gradeErrorRef}
    id="error-message-grade"
    style="visibility: hidden; color: red; text-align: left;"
  >
    学年を選択してください
  </div>
  <from method="grade-post">
    <div bind:this={gradeRef} class="grade-selecter">
      <label for="grade">学年</label>
      <select name="grade-select" bind:value={ansGrade} on:blur={nonGrade}>
        <option value="">選択してください</option>
        {#each gradeList as grade}
          <option value={grade}>{grade.grade}</option>
        {/each}
      </select>
    </div>
  </from>
  <div
    bind:this={genderErrorRef}
    id="error-message-gender"
    style="visibility: hidden; color: red; text-align: left;"
  >
    性別を選択してください
  </div>
  <from method="gender-post">
    <div bind:this={genderRef} class="gender-selecter">
      <label for="gender">性別</label>
      <select name="gender-select" bind:value={ansGender} on:blur={nonGender}>
        <option value="">選択してください</option>
        {#each genderList as gender}
          <option value={gender}>{gender.gender}</option>
        {/each}
      </select>
    </div>
  </from>
  <h4 style="margin-top: 15%; margin-bottom:5%;">
    以下の質問に回答してください。
  </h4>
  {#each testList as test, num}
    <div class="questionnaires">
      <div
        bind:this={errorRefs[num]}
        class="error-message"
        style="visibility: hidden; color: red; text-align: left;"
      >
        この設問に回答してください
      </div>
      <div class="questionnaire">
        <div
          style="height: fit-content; width: fit-content; padding: 0.5em; background-color: #3f51b5; color: white; border-radius: 4px;"
        >
          {"Q" + String(num + 1)}
        </div>
        <div style="padding: 0.5em; padding-left: 0.5em; margin: auto 0;">
          {test.question}
        </div>
      </div>
      {#if test.type === "choice"}
        <table
          bind:this={questionnaireRefs[num]}
          class="select-table"
          style="width: 100%; margin-top: 1em;"
        >
          <tr>
            {#each test.options as ansLevel, i}
              <div class="check-box-column">
                <label
                  ><input
                    type="radio"
                    bind:group={answers[num]}
                    value={i}
                    on:click={() => nextScroll(num)}
                    style="transform:scale(1.2); margin: 10px;"
                  />
                  {ansLevel}
                </label>
              </div>
            {/each}
          </tr>
        </table>
      {:else if test.type === "text"}
        <input
          bind:this={questionnaireRefs[num]}
          type="text"
          bind:value={answers[num]}
          style="margin-top: 1em; margin-left: 1em;"
          maxlength="50"
        />
      {/if}
    </div>
  {/each}
  <div class="next-button">
    <button class="indigo" disabled={isLocked} on:click={questionAnswer}
      >次へ</button
    >
  </div>
  </div>
{/if}

<style lang="scss">
  .wrapper {
    scroll-behavior: smooth;
  }
  .questionnaires {
    margin-bottom: 10%;
  }
  .questionnaire {
    display: grid;
    grid-template-columns: 3em auto;
    grid-template-rows: auto;
    place-items: center;
    justify-content: start;
    border-bottom: solid;
  }
  .check-box-column {
    flex-direction: column;
    margin-left: 1em;
  }
  .grade-selecter {
    width: fit-content;
  }
  .gender-selecter {
    width: fit-content;
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) {
    .wrapper {
      padding: 0 2rem;
      max-width: 900px;
      margin: 0 auto;
    }

    .questionnaires {
      margin-bottom: 8%;
    }

    .questionnaire {
      grid-template-columns: 4em auto;
      padding: 1rem 0;
    }

    .check-box-column {
      margin-left: 1.5em;
    }

    .check-box-column label {
      font-size: 1.1rem;
      line-height: 1.5;
    }

    .check-box-column input[type="radio"] {
      transform: scale(1.4);
      margin: 15px;
    }

    .grade-selecter select,
    .gender-selecter select {
      padding: 0.6em;
      font-size: 1.1rem;
      min-width: 200px;
    }

    .grade-selecter label,
    .gender-selecter label {
      font-size: 1.1rem;
      margin-right: 1rem;
    }

    input[type="text"],
    input[type="number"] {
      font-size: 1.1rem;
      padding: 0.6em;
      width: 300px;
    }

    h4 {
      font-size: 1.3rem;
      line-height: 1.5;
    }
  }
</style>
